export default "__VITE_ASSET__Dn9hVvPi__ 1920w";